//C:\Users\rahul\pharma-billing-saas\frontend\src\app\store\suppliers\supplier.effects.ts
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as SupplierActions from "./supplier.actions";
import { catchError, map, mergeMap, of, switchMap } from "rxjs";
import { SupplierService } from "app/modules/masters/supplier/supplier.service";

@Injectable()
export class SupplierEffects {
  constructor(
    private actions$: Actions,
    private supplierService: SupplierService
  ) {}

  loadSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.loadSupplier),
      mergeMap(({ id }) =>
        this.supplierService.getSupplierById(id).pipe(
          map((supplier) => SupplierActions.loadSupplierSuccess({ supplier })),
          catchError((error) =>
            of(SupplierActions.loadSupplierFailure({ error }))
          )
        )
      )
    )
  );

  createSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.createSupplier),
      mergeMap(({ supplier }) =>
        this.supplierService.createSupplier(supplier).pipe(
          map((createdSupplier) =>
            SupplierActions.createSupplierSuccess({ supplier: createdSupplier })
          ),
          catchError((error) => {
            // Pass structured body when present (e.g. { message, field } for duplicate GST)
            const body = error?.error;
            const err = body && typeof body === 'object' && body.message != null
              ? { message: body.message, field: body.field }
              : (body?.message || error?.message || 'Failed to create supplier');
            return of(SupplierActions.createSupplierFailure({ error: err }));
          })
        )
      )
    )
  );

  // updateSupplier$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(SupplierActions.updateSupplier),
  //     mergeMap(({ id, supplier }) =>
  //       this.supplierService.updateSupplier(id, supplier).pipe(
  //         map((updatedSupplier) =>
  //           SupplierActions.updateSupplierSuccess({ supplier: updatedSupplier })
  //         ),
  //         catchError((error) =>
  //           of(SupplierActions.updateSupplierFailure({ error }))
  //         )
  //       )
  //     )
  //   )
  // );
  updateSupplier$ = createEffect(() =>
  this.actions$.pipe(
    ofType(SupplierActions.updateSupplier),
    switchMap(({ id, supplier }) =>
      this.supplierService.updateSupplier(id, supplier).pipe(
        map((updatedSupplier) => SupplierActions.updateSupplierSuccess({ supplier: updatedSupplier })),
        catchError((error) => {
          // Pass structured body when present (e.g. { message, field } for duplicate GST)
          const body = error?.error;
          const err = body && typeof body === 'object' && body.message != null
            ? { message: body.message, field: body.field }
            : (body?.message || error?.message || 'Failed to update supplier');
          return of(SupplierActions.updateSupplierFailure({ error: err }));
        })
      )
    )
  )
);


  softDeleteSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.softDeleteSupplier),
      mergeMap(({ id }) =>
        this.supplierService.softDeleteSupplier(id).pipe(
          map(() => SupplierActions.softDeleteSupplierSuccess({ id })),
          catchError((error) =>
            of(SupplierActions.softDeleteSupplierFailure({ error }))
          )
        )
      )
    )
  );

  hardDeleteSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.hardDeleteSupplier),
      mergeMap(({ id }) =>
        this.supplierService.hardDeleteSupplier(id).pipe(
          map(() => SupplierActions.hardDeleteSupplierSuccess({ id })),
          catchError((error) =>
            of(SupplierActions.hardDeleteSupplierFailure({ error }))
          )
        )
      )
    )
  );

  searchSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierActions.searchSuppliers),
      mergeMap((action) =>
        this.supplierService
          .searchSuppliers(
            action.term,
            action.page,
            action.limit,
            action.storeId
          )
          .pipe(
            map((paginatedSuppliers) =>
              SupplierActions.searchSuppliersSuccess({
                suppliers: paginatedSuppliers.data,
              })
            ),
            catchError((error) =>
              of(SupplierActions.searchSuppliersFailure({ error }))
            )
          )
      )
    )
  );
}
